import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateHelperModule } from '../translate-helper.module';
import { DeleteConfirmDialogModule } from '../delete-confirm-dialog/delete-confirm-dialog.module';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { TableFieldsDialogComponent } from './table-fields-dialog.component';
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [
    TableFieldsDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    RouterModule,
    TranslateHelperModule,
    DeleteConfirmDialogModule,

    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    DragDropModule,
    MatDialogModule,
    MatListModule,
  ],
  exports: [
    TableFieldsDialogComponent,
  ],
})
export class TableFieldsDialogModule {
}
